module.exports = new __parcel__URL__("progress-in-idea-darkmode.68052358.svg").toString();